import { usePollingJob } from '@shared/hooks';

import { TBulkImport } from '../types/bulkImports.types';

export const usePollBulkImport = () =>
  usePollingJob<TBulkImport>({
    queryKeyPrefix: 'bulk-import',
    endpoint: '/items/import',
    progressMessage: 'Importing...',
    successMessage: 'Import complete.',
    failureMessage: 'Import failed. We have contacted your support team.',
    pollingInterval: 1500,
  });
